import { Vehicle, VehicleLocation } from 'server'
import useLocalStorageValue from '../../views/Map/RightSider/Options/hooks/useLocalStroageValue'
import { filterByLocalStorage } from '../../components/Plotters/CustomAdvancedMarkerClusterer/utils'
import { arrayToMap, getAllData } from '../../utils/data'
import { useContext } from 'react'
import { MapSettingsContext } from '../../contexts/MapSettingsContext'
import MapSettingsContextInterface from '../../contexts/MapSettingsContext/MapSettingsContextInterface'
import { useQuery } from '@tanstack/react-query'
import { useFeathersClient } from '@strac/react-client-feathers'

const useDefaultVehicleFilter = (vehicles: Vehicle[], vehicleLocations: VehicleLocation): any => {
  const { selectedCollections } = useContext(MapSettingsContext) as MapSettingsContextInterface

  const client = useFeathersClient()

  const collectionDevicesQuery = {
    collection_id: {
      $in: selectedCollections
    },
    active: 1
  }
  const { data: collectionDevices } = useQuery({
    queryKey: ['collection-device', 'find', collectionDevicesQuery],
    queryFn: () => getAllData(client, 'collection-device', collectionDevicesQuery),
    placeholderData: [],
    enabled: selectedCollections?.length > 0
  })

  const ground = useLocalStorageValue('assettrak_ground_units')
  const ambus = useLocalStorageValue('assettrak_ambus_units')
  const air = useLocalStorageValue('assettrak_air_units')
  const texasMask = useLocalStorageValue('assettrak_texas_mask')

  const vehicleMap = arrayToMap(vehicles, 'vehicle_id')

  return filterByLocalStorage(
    vehicleLocations,
    vehicleMap,
    selectedCollections,
    collectionDevices,
    texasMask,
    ground,
    air,
    ambus
  )
}

export default useDefaultVehicleFilter
